import React from "react";
import { Navigate, useLocation, Outlet} from "react-router-dom";
import { isAuthenticated } from "./index";
import { signinPathFor } from "./postAuthRedirect";
import { Family} from "../pageInside/Rolle"

const PrivateRoute = ({
    redirectPath = "/your-step",
    children,
}) => {

    let location = useLocation()
    // A visitor signs in first and comes back here; a signed-in account
    // without the role gets the existing fallback page.
    if (!isAuthenticated()) {
        return <Navigate to={signinPathFor(location)} replace state={{ from: location }} />;
    }
    if (!Family()) {
        return <Navigate
            to={redirectPath} replace state={{ from: location }}
        />;
    }
    <Outlet />
    return children;
}

export default PrivateRoute;
